import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT, fonts } from '../styles'

const RECAP_DESKTOP_BREAKPOINT = 1120

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  min-height: 480px;
  position: relative;
  width: 100%;
  padding: 0 50px;

  @media screen and (max-width: ${RECAP_DESKTOP_BREAKPOINT - 1}px) {
    padding: 0 30px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    margin-bottom: 30px;
  }
`

export const ShapeContainer = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 1;
`

export const Title = styled.div`
  margin-bottom: 10px;
  ${fonts.AN_30_600_38}
  text-align: center;
  color: ${theme.colors.white};
`

export const SubTitle = styled.div`
  ${fonts.AN_16_400_24}
  display: flex;
  text-align: center;
  color: ${theme.colors.white};
  margin-bottom: 30px;
`

export const SquirrelAvatar = styled.img`
  width: 100px;
  margin-bottom: 30px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    width: 120px;
  }
`

export const DownButton = styled.button`
  border: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
  transform: rotate(-90deg);
  cursor: pointer;
  width: 44px;
  height: 44px;
  background: ${theme.colors.white};
  border-radius: 100px;
`

export const LgBarkRectangle = styled.img`
  position: absolute;
  left: -175px;
  top: 105px;

  @media screen and (max-width: ${RECAP_DESKTOP_BREAKPOINT -
    1}px) and (min-width: ${RECAP_XS_BREAKPOINT + 1}px) {
    left: -250px;
    top: 115px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    left: -310px;
    top: 195px;
  }
`

export const LgLightOak = styled.img`
  position: absolute;
  right: -335px;
  top: -55px;

  @media screen and (max-width: ${RECAP_DESKTOP_BREAKPOINT -
    1}px) and (min-width: ${RECAP_XS_BREAKPOINT + 1}px) {
    right: -395px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    right: -405px;
    top: -80px;
  }
`

export const MdDuskTriangle = styled.img`
  bottom: 0;
  left: 30px;
  position: absolute;
`

export const SmLightOakCircle = styled.img`
  position: absolute;
  left: 105px;
  bottom: 110px;
`

export const MdBeigeRectangle = styled.img`
  position: absolute;
  right: 0;
  bottom: 5px;
`

export const MobileShapes = styled.div`
  bottom: -30px;
  height: 100%;
  position: absolute;
  width: 100%;

  @media screen and (min-width: ${RECAP_XS_BREAKPOINT}px) {
    display: none;
  }
`
